import React from 'react'
import { makeStyles, Button } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
   secondaryButton: {
      color: '#3264DC',
      backgroundColor: '#fff',
      border: '1px solid #3264DC',
      fontWeight: 'bold',
      margin: theme.spacing(2, 0, 1, 0)
   }
}))

function SecondaryButton({ text, onClick }) {
   const classes = useStyles()

   return (
      <Button
         variant="contained"
         className={classes.secondaryButton}
         fullWidth
         disableElevation
         onClick={onClick}
      >
         {text}
      </Button>
   )
}

export default SecondaryButton
